var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6.3175V2.7025L5.875 0.25L0.25 2.7025V6.385C0.25 9.79 2.65 12.9775 5.875 13.75C6.2875 13.6525 6.685 13.51 7.075 13.3375C7.885 14.4925 9.2275 15.25 10.75 15.25C13.2325 15.25 15.25 13.2325 15.25 10.75C15.25 8.5225 13.63 6.6775 11.5 6.3175ZM6.25 10.75C6.25 11.17 6.31 11.5825 6.4225 11.965C6.2425 12.0475 6.0625 12.13 5.875 12.19C3.4975 11.44 1.75 9.01 1.75 6.385V3.685L5.875 1.885L10 3.685V6.3175C7.87 6.6775 6.25 8.5225 6.25 10.75ZM10.75 13.75C9.0925 13.75 7.75 12.4075 7.75 10.75C7.75 9.0925 9.0925 7.75 10.75 7.75C12.4075 7.75 13.75 9.0925 13.75 10.75C13.75 12.4075 12.4075 13.75 10.75 13.75Z",
    fill: "white",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon_account.80dd68083dee010dc29e28c54c50e08b.svg";
export { ForwardRef as ReactComponent };